import { Instance, types } from "mobx-state-tree";

export const MesssageModel = types.model({
  mainKey: types.optional(types.string, ""),
  detailsKey: types.array(types.string),
});

export const ValidationMesssageModel = types.model({
  message: MesssageModel,
  context: types.frozen(),
});

export type ValidationMesssage = Instance<typeof ValidationMesssageModel>;
export type ValidationMesssageDetails = Instance<typeof MesssageModel>;
